import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DateConversion from "../../../utils/DateConversion";
import { useCurrencySymbol } from "../../../utils/currencyUtils";
import { fetchLeads } from "../../../store/slices/leadsSlice";
import { fetchWorkEntries, fetchWorkEntriesProjectTracking } from "../../../store/slices/workentriesSlice";
import { fetchDescriptionTasks, fetchDescriptionTasksProjectTracking } from "../../../store/slices/DescriptionTask";
import { fetchHardwareDescriptions, fetchHardwareProjectTracking } from "../../../store/slices/hardwareDescriptionSlice";
import { fetchEmployees } from "../../../store/slices/employeeSlice";
import { fetchAllProjects } from "../../../store/slices/projectsSlice";
import AdminLoader from "../../../components/common/loader/AdminLoader";
import AssignShowTasks from "../../Operations/SalesOperations/SaleOperation/ProjectAssignSales/AssignShowTasks";
import useMatchedProject from "./useMatchedProject";
import { setcurrentLeadID, setCurrentPageTitle } from "../../../store/slices/pageSlice";
import { useNavigate } from "react-router-dom";
import { clearWizardState, goNext, goToStep } from "../../../store/slices/WizardSlice/wizardStepSlice";
import { fetchGroups } from "../../../store/slices/groupSlice";

const ProjectAssignedWizard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { formatDateByCountry } = DateConversion();
  const currency = useCurrencySymbol();
  const { employees } = useSelector((state) => state.employees);
  const { projects } = useSelector((state) => state.projects);
  const { entries } = useSelector((state) => state.workentries);
  const { items } = useSelector((state) => state.hardwareDescription);
  const { tasks } = useSelector((state) => state.descriptionTasks);
  const [rowName, setRowName] = useState(null)
  const { leads } = useSelector((state) => state.leads);
  const { group: groups } = useSelector((state) => state.group);
  const wizardPlanState = useSelector((state) => state.wizardstep.wizardPlanState);
  const wizardProjectState = useSelector((state) => state.wizardstep.wizardProjectState);

  const { projectTrackingWorkEntries } = useSelector(
    (state) => state.workentries
  );
  const { hardwareProjectTracking } = useSelector(
    (state) => state.hardwareDescription
  );
  const { descriptionProjectTracking } = useSelector(
    (state) => state.descriptionTasks
  );

  useEffect(() => {
    dispatch(fetchLeads());
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(fetchDescriptionTasksProjectTracking());
    dispatch(fetchHardwareProjectTracking());
    dispatch(fetchWorkEntries());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchDescriptionTasks());
    dispatch(fetchEmployees());
    dispatch(fetchAllProjects());
    dispatch(fetchGroups());
  }, [dispatch]);

  const groupNameById = React.useMemo(() => {
    const map = new Map();
    (groups || []).forEach((g) => {
      const id = g?._id || g?.id;
      const name = g?.newGroupName || g?.groupname || g?.groupName || g?.name || "";
      if (id && name) map.set(String(id), name);
    });
    return map;
  }, [groups]);

  const getDisplayGroupName = React.useCallback(
    (item) => {
      const groupId = item?.groupid?._id || item?.groupid;
      if (groupId && groupNameById.has(String(groupId))) {
        return groupNameById.get(String(groupId));
      }
      return item?.AssignedGroup || "";
    },
    [groupNameById]
  );

  const createdProject = useSelector((state) => state.wizardstep.createdProject);
  const operationProjectName = createdProject[0]?.ProjectName
  const { matchedProject } = useMatchedProject(operationProjectName);

  useEffect(() => {
    dispatch(setCurrentPageTitle("Project Assigned"));
  }, [dispatch]);


  const [sortedProjects, setSortedProjects] = useState([]);

  console.log("sortedProjects 1", sortedProjects)

  useEffect(() => {
    if (matchedProject?.length > 0) {
      // const isProjecttracking = matchedProject[0]?.Projects?.filter((proj) => proj?.isProjecttracking)
      setSortedProjects(matchedProject);
    }
  }, [matchedProject]);


  const [isLoading, setIsLoading] = useState(false);
  const [openInputReceived, setOpenInputReceived] = useState(null);

  const [selected, setSelected] = useState(false);

  const responseassignref = useRef(null);
  useEffect(() => {
    if ((rowName)) {
      // Scroll to the right end of the container
      const scrollToPosition = responseassignref.current.scrollWidth;
      responseassignref.current.scrollTo({
        left: scrollToPosition,
        behavior: 'smooth'
      });
    }
  }, [rowName]);

  const dropdownRefOpenInput = useRef([]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openInputReceived !== null &&
        dropdownRefOpenInput.current[openInputReceived] &&
        !dropdownRefOpenInput.current[openInputReceived].contains(event.target)
      ) {
        setOpenInputReceived(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openInputReceived]);

  const handlerefresh = () => {
  }


  return (
    <div>
      <>
        <div className="pt-3 ">
          {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}

          <>
            <div ref={responseassignref} className="w-[99%] bg-white h-full  min-h-[15rem] max-h-[90vh] overflow-auto pb-12">
              <div className="sticky top-0 z-[1299] bg-[#E8E8E8]">
                <div className="flex w-full  text-xs  text-center text-black">
                  <div className={`bg-[#E8E8E8] font-semibold flex ${rowName ? "" : "w-[80%]"}`}>
                    <div className="w-12 flex justify-center items-center">Sr. No</div>
                    <div className={` ${rowName ? "w-28" : "w-[20%]"} p-2 break-words text-wrap flex justify-around items-center align-middle `} >
                      Group

                    </div>
                    <div className={` ${rowName ? "w-28" : "w-[20%]"} p-2 break-words text-wrap flex justify-center items-center`} >
                      Client Name
                    </div>
                    <div className={` ${rowName ? "w-28" : "w-[20%]"} p-2 break-words text-wrap flex justify-around items-center align-middle" `}>
                      Project
                    </div>
                    <div className={` ${rowName ? "w-28" : "w-[20%]"} p-2 break-words text-wrap flex justify-around items-center align-middle `}>
                      Date <br /> Requested{" "}
                    </div>
                    <div className={` ${rowName ? "w-28" : "w-[20%]"} p-2 break-words text-wrap flex justify-around items-center align-middle `}>
                      Due Date
                    </div>


                  </div>
                  {rowName ? (
                    <div className="flex  ">
                      <div className="flex font-semibold bg-[#E8E8E8]">
                        <div className="w-36  flex justify-center items-center border break-words text-wrap">
                          Manager Details
                        </div>
                        <div className=" w-48  border break-words text-wrap flex ">
                          <div className="w-[50%] flex justify-center items-center">
                            Hours/Parts
                          </div>
                          <div className="w-[50%] flex justify-center items-center">
                            Expenses ({currency})
                          </div>
                        </div>
                      </div>

                      <div className="flex font-semibold bg-[#E8E8E8]">
                        <div className="w-36  border break-words text-wrap flex justify-center items-center">
                          Employee Details
                        </div>
                        <div className="w-52  border break-words text-wrap flex">
                          <div className="w-[50%]  flex justify-center items-center">
                            Hours/Parts
                          </div>
                          <div className="w-[50%] flex justify-center items-center">
                            Expenses ({currency})
                          </div>
                        </div>
                      </div>

                      <div className="font-semibold flex flex-col w-52 text-[12px]">
                        <div className="bg-[#E8E8E8] h-[50%] border break-words text-wrap flex justify-center items-center" >
                          Total
                        </div>
                        <div className=" bg-[#E8E8E8] h-[50%] border break-words text-wrap flex ">
                          <div className="w-[50%] flex justify-center items-center">
                            Hours/Parts
                          </div>
                          <div className="w-[50%] flex justify-center items-center">
                            Expenses ({currency})
                          </div>
                        </div>
                      </div>

                      <div className="font-semibold w-44 bg-[#E8E8E8] flex justify-center items-center border p-2 break-words text-wrap">
                        Action
                      </div>
                    </div>
                  ) : (
                    <div className="font-semibold w-[20%] bg-[#E8E8E8] flex justify-center  items-center  ">
                      Input Details
                    </div>
                  )}
                </div>
              </div>

              <div className="w-full">
                {sortedProjects.map((row, index) => {
                  const matchedRowWorkEntries =
                    projectTrackingWorkEntries.filter(
                      (entry) => entry.projectid === row._id
                    );

                  const matchedRowDesctiption =
                    descriptionProjectTracking.filter(
                      (entry) => entry.projectid === row._id
                    );
                    const matchedLead = leads?.find((proj) => proj?.ProjectName === row?.ProjectName)

                  return (
                    <div
                      className={`flex text-xs ${matchedLead?.isRead === false ? "font-bold" : " "} w-full ursor-pointer group  cursor-pointer`}

                      key={index}
                    >
                      <div className={` flex ${rowName ? "" : "w-[80%]"}`}>
                        <div onClick={() => {
                          setRowName(rowName === row.ProjectName ? null : row.ProjectName)
                          setSelected(!selected)
                        }}
                          className="w-12 pl-2 text-center border-b flex justify-center align-middle items-center group-hover:bg-gray-100">
                          {index + 1}
                        </div>
                        <div onClick={() => {
                          setRowName(rowName === row.ProjectName ? null : row.ProjectName)
                          setSelected(!selected)
                        }}
                          className={` ${rowName ? "w-28" : "w-[20%]"} border-b flex justify-center align-middle items-center group-hover:bg-gray-100 p-2 break-words text-wrap `}>
                          {getDisplayGroupName(row)}
                        </div>
                        <div className={` ${rowName ? "w-28" : "w-[20%]"} border-b p-2 flex justify-center align-middle items-center text-center break-words text-wrap group-hover:bg-gray-100`}>
                          {createdProject[0]?.ClientName}
                        </div>
                        <div onClick={() => {
                          setRowName(rowName === row.ProjectName ? null : row.ProjectName)
                          setSelected(!selected)
                        }}
                          className={` ${rowName ? "w-28" : "w-[20%]"} border-b flex justify-center align-middle items-center text-center p-2 break-words group-hover:bg-gray-100 text-wrap overflow-hidden text-ellipsis line-clamp-2 break-all leading-snug text-xs `}>
                          {row.ProjectName}
                        </div>
                        <div onClick={() => {
                          setRowName(rowName === row.ProjectName ? null : row.ProjectName)
                          setSelected(!selected)
                        }}
                          className={` ${rowName ? "w-28" : "w-[20%]"} border-b flex justify-center align-middle items-center p-2 break-words text-wrap group-hover:bg-gray-100`}>
                          {row.DateRequested &&
                            !isNaN(new Date(row.DateRequested))
                            ? formatDateByCountry(row.DateRequested)
                            : " "}
                        </div>
                        <div onClick={() => {
                          setRowName(rowName === row.ProjectName ? null : row.ProjectName)
                          setSelected(!selected)
                        }}
                          className={` ${rowName ? "w-28" : "w-[20%]"} border-b flex justify-center align-middle items-center p-2 break-words text-wrap group-hover:bg-gray-100`}>
                          {row.ProjectDueDate &&
                            !isNaN(new Date(row.ProjectDueDate))
                            ? formatDateByCountry(row.ProjectDueDate)
                            : " "}
                        </div>
                      </div>

                      {rowName === row.ProjectName ? (
                        <>
                          <div className="projetdetails flex border-b">
                            <AssignShowTasks
                              row={row}
                              employees={employees}
                              index={index}
                              setIsLoading={setIsLoading}
                              matchedRowWorkEntries={matchedRowWorkEntries}
                              matchedRowDesctiption={matchedRowDesctiption}
                              projectTrackingWorkEntries={
                                projectTrackingWorkEntries
                              }
                              hardwareProjectTracking={hardwareProjectTracking}
                              descriptionProjectTracking={
                                descriptionProjectTracking
                              }
                              items={items}
                              entries={entries}
                              projects={projects}
                              tasks={tasks}
                              leads={leads}
                              handlerefresh={handlerefresh}
                            />
                          </div>

                        </>
                      ) : (
                        <div

                          onClick={() => {
                            setRowName(rowName === row.ProjectName ? null : row.ProjectName)
                            setSelected(!selected)
                          }}
                          className={` ${rowName ? "w-full" : "w-[20%]"} group-hover:bg-gray-100 cursor-pointer flex justify-center align-middle items-center border-b`}>

                          {rowName ? (
                            <div className='w-full flex'>
                              <div className="w-36 p-2"></div>
                              <div className="w-48 p-2"></div>
                              <div className="w-36 p-2"></div>
                              <div className="w-52 p-2 flex justify-center align-middle items-center">
                                Multiple
                              </div>
                              <div className="w-52  p-2"></div>
                              <div className="w-44 p-2"></div>
                            </div>
                          ) : (
                            <div className="border-none">
                              Multiple
                            </div>
                          )}
                        </div>
                      )
                      }

                    </div>
                  );
                })}
                {sortedProjects.length === 0 && (
                  <div className="noDataAvailable p-2">No Result Found</div>
                )}
              </div>
            </div>
          </>
          <div className="flex justify-end w-[99%]">
            <div className="flex gap-4 pt-2">
              <button
                onClick={() => dispatch(goToStep(1))}
                className=" py-2 px-7 bg-black overflow-hidden shadow-md text-white rounded-lg"
              >
                Back
              </button>
              <button
                onClick={() => {
                  if (wizardPlanState === "advancedplan" && wizardProjectState === "existingProject") {
                    navigate("/dashboard");
                    dispatch(clearWizardState())
                    dispatch(setcurrentLeadID())
                  } else {
                    dispatch(goNext())
                  }
                }}

                className=" py-2 px-7 bg-[#e32278] overflow-hidden shadow-md text-white rounded-lg"
              >
                {wizardPlanState === "advancedplan" && wizardProjectState === "existingProject" ? "Save" : "Next"}
              </button>

            </div>
          </div>
        </div>

      </>
    </div >
  );
};

export default ProjectAssignedWizard;
